import { styled } from "@mui/material/styles";
import { Box, Button, Chip, TableRow, Typography } from "@mui/material";
import { ramps, semantic, hexToRGBA } from "../../../common/theme/brandTokens";

export const ModelSelectButton = styled(Button)(({ theme }) => ({
  flexShrink: 0,
  height: 24,
  fontSize: 11,
  fontWeight: 600,
  textTransform: "none",
  border: "none",
  color: theme.palette.text.primary,
  paddingLeft: 8,
  paddingRight: 8,
  whiteSpace: "nowrap",
  overflow: "hidden",
  "& .MuiButton-endIcon": { marginLeft: 2 },
}));

export const AllRunsButton = styled(Button)(({ theme }) => ({
  flexShrink: 0,
  height: 24,
  fontSize: 10,
  fontWeight: 500,
  textTransform: "none",
  borderRadius: "4px",
  borderColor: theme.palette.divider,
  color: theme.palette.text.primary,
  paddingLeft: 8,
  paddingRight: 8,
  whiteSpace: "nowrap",
  "&:hover": {
    borderColor: theme.palette.text.primary,
  },
}));

/** Dropdown trigger that shows which measurement day the vitals are from. */
export const VitalsSelectButton = styled(Button)(({ theme }) => ({
  flexShrink: 0,
  height: 26,
  gap: "4px",
  fontSize: 11,
  textTransform: "none",
  borderRadius: "6px",
  borderColor: theme.palette.divider,
  color: theme.palette.text.primary,
  paddingLeft: 10,
  paddingRight: 6,
  whiteSpace: "nowrap",
  "&:hover": {
    borderColor: theme.palette.text.primary,
  },
}));

/** Conversation title shown on the same row as the vitals date dropdown. */
export const ConversationTitle = styled(Typography)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: "15px",
  fontWeight: 400,
  marginLeft: "12px",
  color: theme.palette.text.secondary,
}));

export const RunChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  borderRadius: "4px",
  backgroundColor: isSelected
    ? theme.palette.text.primary
    : theme.palette.mode === "dark" ? ramps.neutral[600] : ramps.neutral[300],
  color: isSelected ? theme.palette.background.paper : theme.palette.common.white,
  fontWeight: isSelected ? 600 : 400,
  fontSize: "10px",
  "&:hover": {
    backgroundColor: isSelected
      ? theme.palette.text.secondary
      : theme.palette.mode === "dark" ? ramps.neutral[500] : ramps.neutral[400],
  },
}));

export const StatusChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "isActive",
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  height: 18,
  fontSize: 9,
  fontWeight: 600,
  borderRadius: "3px",
  backgroundColor: isActive
    ? theme.palette.mode === "dark" ? hexToRGBA(semantic.success.main, 0.25) : semantic.success.tint
    : theme.palette.action.hover,
  color: isActive ? semantic.success.main : theme.palette.text.secondary,
}));

export const ClickableTableRow = styled(TableRow)({
  cursor: "pointer",
  "&.Mui-selected": {
    backgroundColor: "action.selected",
  },
});

export const ChipScrollRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
  gap: 4,
  overflowX: "auto",
  alignItems: "center",
  "&::-webkit-scrollbar": { display: "none" },
});
